import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { sustainabilityPoints } from "@/mocks/siteData";

export default function SustainabilitySection() {
  return (
    <section id="sustainability" className="sun-glaze bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
                Sustainable Rural Tourism
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
              Travel With Purpose
            </h2>
            <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
              Rythugaru Agri Tourism aims to create experiences that respect farmers, communities,
              culture, nature, and the land. We encourage responsible tourism that:
            </p>
            <div className="mt-8 bg-secondary-100 rounded-lg p-6">
              <p className="font-heading text-xl md:text-2xl text-secondary-900 leading-snug">
                Experience rural India. Respect rural India. Support rural communities.
              </p>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={120}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {sustainabilityPoints.map((point) => (
                <div
                  key={point}
                  className="flex items-start gap-3 bg-background-100 border border-background-200 rounded-lg p-5"
                >
                  <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 mt-0.5">
                    <i className="ri-check-line text-base"></i>
                  </span>
                  <span className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {point}
                  </span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}